// src/pages/ForgotPassword.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Container, Typography, Box, Alert } from '@mui/material';
import axios from 'axios';
import { primaryColor } from '../theme';
import logo from '../assets/Equity logo.png';
import illustration from '../assets/Equity logo.png';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleInputChange = (e) => {
    setEmail(e.target.value);
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/auth/forgot-password`, { email });
      setSuccess(response.data.msg);
      setTimeout(() => {
        navigate('/login');
      }, 3000); // Redirect to login page after 3 seconds
    } catch (error) {
      console.error('Error sending password reset email:', error);
      setError(error.response?.data?.msg || 'Failed to send password reset email');
    }
  };

  return (
    <Box display="flex" height="100vh">
      <Box
        flex={1}
        display={{ xs: 'none', md: 'flex' }}
        alignItems="center"
        justifyContent="center"
        bgcolor={primaryColor}
      >
        {/* <img src={illustration} alt="Illustration" style={{ width: '80%', height: 'auto' }} /> */}
      </Box>
      <Box
        flex={1}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <Box display="flex" flexDirection="column" alignItems="center">
            <img src={logo} alt="Logo" style={{ width: '150px', marginBottom: '20px' }} />
            <Typography variant="h4" component="h1" gutterBottom>
              Forgot your password?
            </Typography>
            <Typography variant="body1" align="center" gutterBottom>
              Please enter the email address associated with your account and we'll email you a link to reset your password.
            </Typography>
            {error && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {error}
              </Alert>
            )}
            {success && (
              <Alert severity="success" sx={{ mt: 2 }}>
                {success}
              </Alert>
            )}
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                margin="normal"
                value={email}
                onChange={handleInputChange}
                error={!!error}
                helperText={error}
              />
              <Button type="submit" variant="contained" color="primary" fullWidth style={{ backgroundColor: primaryColor }}>
                Send Reset Link
              </Button>
              <Typography variant="body2" align="right" style={{ marginTop: '10px' }}>
                <a href="/login" style={{ color: primaryColor }}>Back to Login</a>
              </Typography>
            </form>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default ForgotPassword;